import TourVariantA from "./TourVariantA";
import TourVariantB from "./TourVariantB";
import { RouteComponentProps, useLocation } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Tour_Variant_A } from "shared/constants/TourConst";
const DEFAULT_VARIANT = Tour_Variant_A;

const Tour: React.FC<RouteComponentProps> = (props) => {
  const { tourVariant } = useFlags();
  const { search }: any = useLocation();

  const params = new URLSearchParams(search);
  const variant = params.get("variant");
  const resolvedVariant = variant || tourVariant || DEFAULT_VARIANT;

  if (resolvedVariant === Tour_Variant_A) return <TourVariantA />;

  return <TourVariantB />;
};

export default Tour;
